import { NgModule, LOCALE_ID } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastrModule } from "ngx-toastr";
import { BarRatingModule } from "ngx-bar-rating";
import { NgxCaptchaModule } from "ngx-captcha";

import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpConfigInterceptor } from "./interceptor/httpconfig.interceptor";
import { PortfolioComponent } from "./portfolio/portfolio.component";
import { SchemePortfolioComponent } from "./scheme-portfolio/scheme-portfolio.component";
import { ShareHoldingComponent } from "./share-holding/share-holding.component";
import { SchemeStatementsComponent } from "./scheme-statements/scheme-statements.component";
import { FeedbackComponent } from "./feedback/feedback.component";

import { SharedModule } from "../shared/shared.module";
import { HomeModule } from "../home/home.module";
import { LayoutModule } from "../layout/layout.module";
import { BlogComponent } from "./blog/blog.component";
import { PmsComponent } from "./pms/pms.component";
import { BlogDetailsComponent } from "./blog/blog-details.component";
import { PartnerComponent } from "./partner/partner.component";

@NgModule({
  declarations: [
    PortfolioComponent,
    ShareHoldingComponent,
    SchemeStatementsComponent,
    FeedbackComponent,
    BlogComponent,
    PmsComponent,
    BlogDetailsComponent,
    PartnerComponent,
    SchemePortfolioComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    BarRatingModule,
    NgxCaptchaModule,
    LayoutModule,
    SharedModule,
    HomeModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: "en-US" }
  ]
})
export class CoreModule {}
